import { Link } from "react-router-dom";
import { itemPath, tileVariantOf } from "../../../utilities/item-kinds";
import FramedImage from "../../../components/FramedImage/FramedImage";
import { issueYear } from "../../../utilities/dates";
import { thumbUrl } from "../../../utilities/image-urls";

export default function StampTile({ item }) {
  const variant = tileVariantOf(item);

  if (variant === "card") {
    return (
      <Link
        to={itemPath(item)}
        state={{ fromFeed: true }}
        className="group relative block h-full rounded-md overflow-hidden bg-cream border border-ink/5"
      >
        <FramedImage
          src={item.image}
          thumbSrc={thumbUrl(item.image)}
          alt={item.subject || "Stamp"}
          framing={item.framing?.tile}
          hoverZoom
          loading="lazy"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/70 to-transparent px-4 pt-8 pb-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/70 mb-1">
            Stamp
          </p>
          <p className="font-serif text-sm text-white leading-snug line-clamp-2">
            {item.subject || item.catalogue_id}
          </p>
          {item.year && (
            <p className="font-mono text-xs text-white/60 mt-1">
              {issueYear(item.year)}
            </p>
          )}
        </div>
      </Link>
    );
  }

  // "image" variant — the scan fills the whole tile
  return (
    <Link
      to={itemPath(item)}
      state={{ fromFeed: true }}
      className="group relative block h-full rounded-md overflow-hidden bg-cream border border-ink/5"
    >
      <FramedImage
        src={item.image}
        thumbSrc={thumbUrl(item.image)}
        alt={item.subject || "Stamp"}
        framing={item.framing?.tile}
        hoverZoom
        loading="lazy"
      />
    </Link>
  );
}
